import Dashboard from "../../pages/Dashboard";

export default Dashboard;
